import React, { Component } from 'react';
import Header from '../component/header/header';
import GuideTitle from '../component/guide/guideTitle';
import '../component/guide/guide.css';
import { Link } from 'react-router-dom';

class Guide02 extends Component {
    render() {
        const {prePath, nextPath} = this.props.guide;
        return (
            <div className="gudie-wrap wrong-wrap d-flex flex-column">
                <article className="header-wrap"><Header /></article>
                
                <section className="main-container d-flex flex-column">
                    <GuideTitle guide={this.props.guide} />
                    <div className="body d-flex justify-content-center scroll-wrapper">
                        <div className="container text-container scroll-wrapper">
                            <p>▶ 다음과 같은 행위는 한국보건의료인국가시험 부정행위자 등 처리지침 제3조에 의거하여 부정행위로 처리됩니다.</p>
                            <ul>
                                <li>대리시험을 치른 행위 또는 치르게 하는 행위</li>
                                <li>시험 중 다른 응시자와 시험과 관련된 대화를 하거나 손동작, 소리 등으로 신호를 하는 행위</li>
                                <li>시험 중 다른 응시자의 모니터를 보고 자신의 답안을 작성하는 행위</li>
                                <li>시험 중 다른 응시자를 위하여 답안 등을 알려주거나 보여주는 행위</li>
                                <li>다른 시험장 내외의 자로부터 도움을 받아 답안을 작성하는 행위 및 도움을 주는 행위</li>
                                <li>시험 전, 후 또는 시험 기간 중에 시험문제, 시험문제에 관한 일부 내용, 답안 등을 다음 각 항목의 방법을 통해 다른 사람에게 알려주거나 알고 시험을 치른 행위</li>
                            </ul>
                            <ol>
                                <li>가. 대화, 쪽지, 기록, 낙서, 그림, 녹음, 녹화</li>
                                <li>나. 홈페이지, SNS 등에 게재 및 공유</li>
                                <li>다. 문제집, 도서, 책자 등의 출판</li>
                            </ol>
                        </div>
                    </div>
                </section>
            
                <footer className="footer-wrap w-100 d-flex justify-content-center align-items-center">
                    <div className="page-btn-wrap d-flex justify-content-center align-content-center">
                        <Link to={prePath}>
                            <button className="btn pre-btn">
                                <span className="icon-wrap">
                                    <svg className="icon pre-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                    </svg>
                                </span>
                                <b>이전</b>
                            </button>
                        </Link>
                        <div className="page-info"><span className="current-page">2</span>&nbsp;/&nbsp;<span className="total-page">5</span></div>
                        <Link to={nextPath}>
                            <button className="btn next-btn">
                                <b>다음</b>
                                <span className="icon-wrap">
                                    <svg className="icon next-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                    </svg>
                                </span>
                            </button>
                        </Link>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Guide02;
